<template>
  <HiddenDownloadForm ref="downloadForm" />
  <el-col :span="24">
    <TableSpinner :loading="pageLoading" style="margin-top: 50px">
      <div :class="$style.downloadButtonContainer">
        <span :class="$style.label">Количество событий: {{ totalEvents }}</span>
        <el-button text class="text-button" :class="$style.downloadButton" @click="exportReportData" style="height: auto !important">
          <font-awesome-icon icon="external-link-alt"/>&nbsp;Экспортировать CSV файл
        </el-button>
      </div>

      <el-table :data="allEvents" style="width: 100%" stripe>
        <el-table-column prop="user_id" label="Пользователь" min-width="130"/>
        <el-table-column prop="phone" label="Номер телефона" min-width="150"/>
        <el-table-column prop="sender" label="Подпись" min-width="150"/>
        <el-table-column prop="channel" label="Тип сообщения" min-width="150" :formatter="messageType"/>
        <el-table-column prop="event" label="Событие" min-width="180"/>
        <el-table-column :formatter="dateTime" label="Дата и время" min-width="150"/>
      </el-table>

      <div class="solo-pagination-container">
        <el-pagination
          background
          class="wide-page-size"
          layout="sizes, prev, pager, next"
          :total="totalEvents"
          :pager-count="3"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :hide-on-single-page="true"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
        >
        </el-pagination>
      </div>
    </TableSpinner>
  </el-col>
</template>

<script>
import HiddenDownloadForm from "@shared/components/layout/download-form.component"
import moment from "moment"

export default {
  name: "EventsTable",
  components: {HiddenDownloadForm},
  props: ["allEvents", "totalEvents", "reportParams", "downloadUrl", "pageLoading"],
  methods: {
    dateTime(row) {
      return moment(row.date).utcOffset(this.$store.getters.user.utcOffset || 0).format("DD.MM.YYYY HH:mm:ss")
    },
    messageType(row){
      switch(row.channel){
        case "sms":
          return "СМС"
        case "vk":
          return "ВК/ОК"
        case "call":
          return CALL_TYPES[row.callType] || ""
        case "telegram":
          return "Telegram"
        default:
          return ""
      }
    },
    handlePageSizeChange(newSize) {
      this.$emit("paginationChanged", {size: newSize})
    },
    handleCurrentPageChange(newPage) {
      if (this.allEvents.length){this.$emit("paginationChanged", {page: newPage})}
    },
    exportReportData() {
      let url = `${this.axios.defaults.baseURL}${this.downloadUrl}`
      let params = this.reportParams
      this.$refs.downloadForm.download(url, params)
    },
  }
}
</script>

<style lang="css" module>
.downloadButtonContainer{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px
}

.downloadButton{
  padding: 0px;
  min-height: auto;
}

.label{
  color: var(--el-text-color-regular);
}
</style>